import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "n20-container",
    attrs: {
      "data-cy": "view-alarm-logs-report-list",
      "fluid": ""
    }
  }, [_c('core-alarm-logs-report-list')], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };